import { c as _c } from "react/compiler-runtime";
import { PatientDynamicFieldType } from "@/types/enums";
import PatientHealthFieldDialog from "./patient-health-field-dialog";
const MEDICAL_HISTORY_CONFIG = {
  type: PatientDynamicFieldType.MEDICAL_HISTORY,
  title: "Medical History",
  description: "Add medical conditions and past diagnoses. Information from patient forms will appear here automatically.",
  placeholder: "e.g., Hypertension, Diabetes",
  addButtonText: "Add medical condition",
  addAnotherButtonText: "Add another condition"
};
interface MedicalHistoryDialogProps {
  children?: React.ReactNode;
  patientId: string;
}
export default function MedicalHistoryDialog(t0) {
  const $ = _c(3);
  const {
    children,
    patientId
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== patientId) {
    t1 = <PatientHealthFieldDialog config={MEDICAL_HISTORY_CONFIG} patientId={patientId}>{children}</PatientHealthFieldDialog>;
    $[0] = children;
    $[1] = patientId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}